import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const AUTH_API_URL = `${process.env.REACT_APP_API_BASE_URL}/auth/connect/`;

export const authApi = createApi({
  reducerPath: 'AUTH',
  baseQuery: fetchBaseQuery({
    baseUrl: AUTH_API_URL,
  }),
  endpoints: (builder) => ({}),
});

// export const { useGetTokenMutation } = authApi;
